import { getWorkerUrl } from "../session";
import { useAuth } from "./useAuth";

/** URL worker du porteur, vide tant qu'elle n'est pas lisible. */
export function useSelfUrl(): string {
  const { user } = useAuth();
  try {
    return getWorkerUrl(user);
  } catch {
    return "";
  }
}
